import { Output } from "valibot";

import { StarterQuestionSchema } from "components/SonicBot/schemas";
import classNames from "shared/utils/classNames";

type Props = {
  starterQuestion: Output<typeof StarterQuestionSchema>;
  onSuggestionClick: (
    starterQuestion: Output<typeof StarterQuestionSchema>,
  ) => Promise<void>;
  isOverButton?: boolean;
};

function StarterQuestionButton(props: Props) {
  const { starterQuestion, onSuggestionClick, isOverButton } = props;

  return (
    <button
      className={classNames(
        "message-button relative rounded-lg border border-solid border-[var(--borderColor)] bg-white",
        "cursor-pointer px-3 py-2 text-left text-[var(--chatBotOrDarkColor)] hover:bg-[var(--starterHoverColor)]",
        isOverButton ? "outside text-sm" : "inside text-xs",
      )}
      onClick={() => onSuggestionClick(starterQuestion)}
    >
      <p>{starterQuestion.question}</p>
      <div className="absolute inset-0 z-[-2] rounded-lg bg-white">&nbsp;</div>
    </button>
  );
}

export default StarterQuestionButton;
